window.addEventListener("DOMContentLoaded", () => {
    let currentQuestionIndex = 0;
    let responses = [];
    const questions = document.querySelectorAll("span[data-question]");
    const content = document.querySelector(".simulator__content");
    const container = document.querySelector(".simulator__container");
    const freeEstimeBtn = document.querySelector(".free__estimate");
    const resetForm = document.querySelector(".resetForm");

    const run = () => {
        const startButton = document.querySelector(".js__simulator__start");

        startButton.addEventListener("click", (e) => {
            e.preventDefault();
            displayQuestion();
        });
    };

    const displayQuestion = () => {
        generateForm();
        listenNextQuestion();
    };

    resetForm.addEventListener("click", () => {
        location.reload();
    })

    const generateForm = () => {
        content.innerHTML = "";
        const currentQuestion = questions[currentQuestionIndex];

        const labelInput = document.createElement("label");
        labelInput.setAttribute("for", "question" + currentQuestionIndex);
        labelInput.setAttribute("class", "simulator__title");
        labelInput.textContent = currentQuestion.dataset.question;
        
        const questionContainer = document.createElement("div");
        questionContainer.setAttribute("class", "simulator__question");
        
        questionContainer.appendChild(labelInput);
        const questionInput = generateSlider(currentQuestion.dataset.unit, parseInt(currentQuestion.dataset.min), parseInt(currentQuestion.dataset.max));

        questionContainer.appendChild(questionInput);

        content.appendChild(questionContainer);

        const buttonContainer = document.createElement("div");
        buttonContainer.setAttribute("class", "simulator__btn");
        
        const nextButton = document.createElement("button");
        nextButton.setAttribute("class", "js__simulator__next");
        nextButton.innerText = "Suivant";

        buttonContainer.appendChild(nextButton);

        content.appendChild(buttonContainer);
    };

    const listenNextQuestion = () => {
        const nextButton = document.querySelector(".js__simulator__next");
        const questionInput = document.querySelector(".js__simulator__input");

        nextButton.addEventListener("click", (e) => {
            e.preventDefault();

            responses.push({ value: questionInput.value });
            currentQuestionIndex++;

            if (questions[currentQuestionIndex] !== undefined) {
                displayQuestion();
            } else {
                displayResult();
            }
        });
    };

    const displayResult = () => {
        content.innerHTML = "";

        const resultUnit = container.dataset.unit;
        let result = container.dataset.result;
        responses.forEach((response, index) => {
            result = result.replace('$' + (index + 1), response.value)
        })

        const resultTitle = document.querySelector("span[data-title]");
        const resultSubTitle = document.querySelector("span[data-subtitle]");

        const title = document.createElement("h2");
        title.textContent = resultTitle.dataset.title;
        title.setAttribute("style", "margin-bottom: 2rem;");

        const resultContainer = document.createElement("div");
        resultContainer.setAttribute("class", "simulator__result");

        const subTitle = document.createElement("div");

        subTitle.textContent = resultSubTitle.dataset.subtitle;
        subTitle.setAttribute("style", "color: #ff580c; font-size: 1.4rem; text-align: left; line-height: 2rem;");

        const text = document.createElement("p");
        text.setAttribute("style", "color: #000; text-align: left");
        text.textContent = eval(result) + ' ' + resultUnit;

        resultContainer.appendChild(subTitle);
        resultContainer.appendChild(text);
        resultContainer.appendChild(freeEstimeBtn);
        content.appendChild(title);
        content.appendChild(resultContainer);
    };

    const generateSlider = (unit, min, max) => {
        const mediumValue = Math.round((max + min) / 2);

        const sliderContainer = document.createElement("div");
        sliderContainer.setAttribute("class", "simulator__slider");

        const questionContainer = document.createElement("div");
        questionContainer.setAttribute("class", "simulator__input");

        const fill = document.createElement("div");
        fill.setAttribute("class", "fill");

        const currentValue = document.createElement("div");
        currentValue.setAttribute("class", "currentValue");
        currentValue.innerText = mediumValue + ' ' + unit;

        const sliderMin = document.createElement("div");
        sliderMin.setAttribute("class", "slider__min");
        sliderMin.innerText = min + ' ' + unit;

        const sliderMax = document.createElement("div");
        sliderMax.setAttribute("class", "slider__max");
        sliderMax.innerText = max + ' ' + unit;

        const questionInput = document.createElement("input");
        questionInput.setAttribute("type", "range");
        questionInput.setAttribute("min", min);
        questionInput.setAttribute("max", max);
        questionInput.setAttribute("value", mediumValue);
        questionInput.setAttribute("id", "slider");
        questionInput.setAttribute("name", "question" + currentQuestionIndex);
        questionInput.setAttribute("class", "js__simulator__input");
    
        questionInput.addEventListener('input', function() {
            const lengthPercentage = ((questionInput.value - min) / (max - min)) * 100;

            fill.style.width = `${lengthPercentage}%`;
            currentValue.textContent = `${questionInput.value} ` + unit;
            currentValue.style.left = `${lengthPercentage}%`;
            if (Math.round(questionInput.value) === min) {
                currentValue.style.left = "-0%";
            }
            currentValue.style.transform = `translateX(-${lengthPercentage}%)`;
        });

        questionContainer.appendChild(questionInput);
        questionContainer.appendChild(fill);

        sliderContainer.appendChild(questionContainer);
        sliderContainer.appendChild(currentValue);
        sliderContainer.appendChild(sliderMin);
        sliderContainer.appendChild(sliderMax);
    
        return sliderContainer;
    }

    run();
});
